import { Stack, Typography } from "@mui/material";
import React from "react";
import { formBuilderParams } from "../FormBuilder";
import ButtonMAS from "ButtonMAS/ButtonMAS";


/**
 * @typedef {Object} buttonConfig
 * @property {string} title
 * @property {import("theme/theme").buttonVariant?} variant
 * @property {(() => void)?} onClick
 * @property {Boolean?} disabled 
 */

/**
 * @typedef {Object} customConfig
 * @property {React.ReactNode} children
 */

/**
 * @typedef {(
*   ({componentType: "button", config?: buttonConfig}) |
*   ({componentType: "custom", config?: customConfig})
* )} sectionExtraConfig
*/

/**
 * @param {Object} props
 * @param {string?} props.title
 * @param {string?} props.titleVariant
 * @param {sectionExtraConfig[]} props.extraConfigs
 * @param {string?} props.padding
 * @param {React.CSSProperties?} props.style
 * @param {React.CSSProperties?} props.innerStyle
 * @param {React.ReactNode | React.ReactNode[]} props.children
 */
const FormBuilderSection = ({ title, titleVariant, extraConfigs = [], padding, style, innerStyle, children }) => {
  const mapButtonVariant = (variant) => {
    if (variant === "outline-normal-button") return "bordered";
    if (variant === "text-only") return "text-only";
    return "primary";
  };

  return (
    <Stack direction="column"
      gap={formBuilderParams.formItemColGap}
      paddingTop={title && formBuilderParams.formSectionTitleTopPadding}
      sx={{ ...style }}
    >
      {
        title && <Stack direction="row" alignItems="center" gap={formBuilderParams.formItemRowGap}>
          <Typography variant={titleVariant}>{title}</Typography>
          {extraConfigs.map((extraConfig, i) => {
            switch (extraConfig.componentType) {
              case "button":
                const { title: buttonTitle, variant: buttonVariant, onClick: buttonOnClick, disabled: buttonDisabled } = extraConfig.config ?? {};
                return <ButtonMAS
                  key={i}
                  variant={mapButtonVariant(buttonVariant)}
                  onClick={buttonOnClick}
                  disabled={buttonDisabled}
                >
                  {buttonTitle}
                </ButtonMAS>;
              case "custom":
                return <>{extraConfig.config?.children}</>;
            }
          })}
        </Stack>
      }
      <Stack
        direction="column"
        gap={formBuilderParams.formItemColGap}
        sx={{ padding, ...innerStyle }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default React.memo(FormBuilderSection);
